const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    minHeight: '50vh',
    padding: '40px 20px',
  },
  message: {
    marginTop: '20px',
    marginBottom: '40px',
  },
  buttonContainer: {
    marginTop: '20px',
  },
  button: {
    padding: '10px 24px',
    fontSize: '16px',
  },
};

export default styles;